import React from "react"
// import { Link } from "gatsby"

import Layout from "../components/layout"
// import Image from "../components/image"
import SEO from "../components/seo"

import {
  Container,
  H1,
  H2,
  H3,
  P,
  A,
  An,
  Code,
  Hr,
  Ul,
  Ol,
  Kbd,
  Highlight,
  Blockquote,
  BlockquoteCaption,
  Images,
} from "../elements"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <Container>
      <H1>Heading 1</H1>
      <H2>Heading 2</H2>
      <H3>Heading 3</H3>
      <P>Paragraph</P>
      <P tAlign={"justify"} margin={"30px 0"}>
        Lorem ipsum dolor sit amet, <em>consectetur adipiscing</em> elit.
        Consectetur pulvinar consequat hendrerit nulla et tempor neque, risus.
        Mauris nulla at <del>imperdiet duis sit euismod quis augue.</del> Quam
        convallis porta pharetra consequat diam laoreet enim. Lorem ipsum dolor
        sit amet.
      </P>
      <span>
        <A to={"/404"}>Link Text</A>
      </span>
      <span style={{ marginLeft: "15px" }}>
        <An href="/404">This is A Tag</An>
      </span>
      <span style={{ marginLeft: "15px" }}>
        <Code>&lt;code&gt;&lt;&#8725;code&gt;</Code>
      </span>
      <span style={{ marginLeft: "15px" }}>
        <Kbd>Ctrl + C</Kbd>
      </span>
      <span style={{ marginLeft: "15px" }}>
        <Highlight>Lorem highlighted</Highlight>
      </span>

      <Hr />
      <Images />
      <Blockquote>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Consectetur
        pulvinar consequat hendrerit nulla hiiijjjet tempor neque, risus. quis
        augue. Quam convallis porta pharetra consequat diam laoreet enim. Lorem
        ipsum pharetra consequatporta diam laoreet enim. ipsum dolor sit amet.
        <BlockquoteCaption>Pablo Escobar</BlockquoteCaption>
      </Blockquote>
      <span>
        <Ol>
          <li>List 1</li>
          <li>List 2</li>
          <li>List 2</li>
          <li>List 4</li>
        </Ol>
        <Ul>
          <li>List 1</li>
          <li>List 2</li>
          <Ol>
            <li>List 1</li>
            <li>List 2</li>
          </Ol>
          <li>List 2</li>
          <li>List 2</li>
        </Ul>
      </span>

      <table>
        <tr>
          <th>#</th>
          <th>Firstname</th>
          <th>Lastname</th>
          <th>Age</th>
        </tr>
        <tr>
          <td>1</td>
          <td>Jill</td>
          <td>Smith</td>
          <td>50</td>
        </tr>
        <tr>
          <td>2</td>
          <td>Eve</td>
          <td>Jackson</td>
          <td>94</td>
        </tr>
        <tr>
          <td>3</td>
          <td>Eve</td>
          <td>Jackson</td>
          <td>94</td>
        </tr>
      </table>
    </Container>
  </Layout>
)

export default IndexPage
